
import { defineComponent, ref } from '@nuxtjs/composition-api'
import ElementHeadline from '~/components/element/elementHeadline.vue'

export default defineComponent({
  components: { ElementHeadline },
  setup() {
    const currentBlock = ref('' as string)
    const toggleBlock = (block: string) => {
      currentBlock.value = currentBlock.value === block ? '' : block
    }
    return { toggleBlock, currentBlock }
  },
})
